<div (window:beforeunload)="ngOnDestroy()" class="asset-summary">
  <div class="component-header">
    <span>RESUMO DE ATIVO</span>
    <div class="icons gridster-ignore-drag">
      <!-- <mat-icon svgIcon="chain"></mat-icon> TODO adicionar quando funcionalidade estiver implementada -->
      <mat-icon *ngIf="!newWindow && showExpandCard" svgIcon="expand" (click)="openNewWindow()"></mat-icon>
      <mat-icon disableWksChange *ngIf="!newWindow && !showClose" svgIcon="close" (click)="removeItemFromWorkspace()"
        matTooltipPosition="above" [matTooltip]="removeFromWksTooltip">
      </mat-icon>
    </div>
  </div>
  <div class="container gridster-ignore-drag" [ngClass]="{'theory': auctionHammer}">
    <app-auction-hammer *ngIf="auctionHammer" [timeToOpen]="timeToOpen" [priceTheory]="priceTheory"
      [varTheory]="varTheory">
    </app-auction-hammer>
    <app-asset-input-header [symbolAutoComplete]="currentSymbol" (onsymbolChanged)="selectAsset($event)"
      [lastTrade]="lastTrade" [coinVariation]="_messageQuote?.coinVariation" [showVariation]="showVariation"
      [hiddenInvalid]="hiddenInvalidActive" [variation]="_messageQuote?.variation"
      [dateLastNegotiation]="_messageQuote?.dateLastNegotiation" [hourLastTrade]="_messageQuote?.hourLastTrade"
      [timeUpdate]="_messageQuote?.timeUpdate" [company]="company" [image]="imgName" [reset]="changingValue">
    </app-asset-input-header>
    <div class="row no-gutters">
      <mat-tab-group class="col-12" (selectedTabChange)="changeTab($event)">
        <mat-tab label="Cotação" class="quotation-content">
          <div class="quotation-content">
            <div class="row no-gutters">
              <div>
                <span class="label">Máxima</span>
                <span class="high">{{ assetValid ? msgQuotesformattedCurrency?.high : '-' }}</span>
              </div>
              <div>
                <span class="label">P. Compra</span>
                <span class="buy">{{ assetValid ? msgQuotesformattedCurrency?.bid : "-" }}</span>
              </div>
            </div>
            <div class="row no-gutters">
              <div>
                <span class="label">Mínima</span>
                <span class="low">{{ assetValid ? msgQuotesformattedCurrency?.low : '-' }}</span>
              </div>
              <div>
                <span class="label">Qtd. Compra</span>
                <span>{{ assetValid ? _messageQuote?.volumeBetterBid : '-' }}</span>
              </div>
            </div>
            <div class="row no-gutters">
              <div>
                <span class="label">Abertura</span>
                <span>{{ assetValid ? msgQuotesformattedCurrency?.open : '-' }}</span>
              </div>
              <div>
                <span class="label">P. Venda</span>
                <span class="sell">{{ assetValid ? msgQuotesformattedCurrency?.ask : "-" }}</span>
              </div>
            </div>
            <div class="row no-gutters">
              <div>
                <span class="label">Fech. Ant.</span>
                <span>{{ assetValid ? msgQuotesformattedCurrency?.previous : '-' }}</span>
              </div>
              <div>
                <span class="label">Qtd. Venda</span>
                <span>{{ assetValid ? _messageQuote?.volumeBetterAsk : '-' }}</span>
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Gráfico">
          <div class="chart-content" [ngClass]="{ 'hide-infos': !assetValid || chart.hidden }">
            <div class="main-bar">
              <span class="current-price"
                [ngStyle]="{'left': chart?.currentPricePosition, 'transform': chart?.currentPriceTransform}">
                {{msgQuotesformattedCurrency?.lastTrade}}
              </span>
              <span class="variation-bar" [ngClass]="{'high': chart?.isPositive}" [ngStyle]="{
                  'left': chart?.barPosition,
                  'width': chart?.barWidth
                }"></span>
              <span *ngIf="chart?.avgPricePosition" class="avg-price"
                [ngStyle]="{'left': chart?.avgPricePosition}"></span>
            </div>
            <div class="min-max-row">
              <span>{{msgQuotesformattedCurrency?.low}}</span>
              <span>{{msgQuotesformattedCurrency?.high}}</span>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Variação">
          <div class="variation-content">
            <div class="row no-gutters">
              <div>
                <span class="label">Semanal</span>
                <span [ngClass]="{'+': 'high', '-': 'low'}[variation?.weekly[0]]">
                  {{ assetValid ? variation?.weekly : '-' }}
                </span>
              </div>
              <div>
                <span class="label">1 Semana</span>
                <span [ngClass]="{'+': 'high', '-': 'low'}[variation?.previousWeek[0]]">
                  {{ assetValid ? variation?.previousWeek : "-" }}
                </span>
              </div>
            </div>
            <div class="row no-gutters">
              <div>
                <span class="label">Mensal</span>
                <span [ngClass]="{'+': 'high', '-': 'low'}[variation?.monthly[0]]">
                  {{ assetValid ? variation?.monthly : '-' }}
                </span>
              </div>
              <div>
                <span class="label">1 Mensal</span>
                <span [ngClass]="{'+': 'high', '-': 'low'}[variation?.previousMonth[0]]">
                  {{ assetValid ? variation?.previousMonth : '-' }}
                </span>
              </div>
            </div>
            <div class="row no-gutters">
              <div>
                <span class="label">Anual</span>
                <span [ngClass]="{'+': 'high', '-': 'low'}[variation?.annual[0]]">
                  {{ assetValid ? variation?.annual : '-' }}
                </span>
              </div>
              <div>
                <span class="label">1 Ano</span>
                <span [ngClass]="{'+': 'high', '-': 'low'}[variation?.previousYear[0]]">
                  {{ assetValid ? variation?.previousYear : "-" }}
                </span>
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Volume">
          <div class="volume-content">
            <div class="row no-gutters">
              <div>
                <span class="label">Quantidade</span>
                <span>{{ assetValid ? _messageQuote?.quantity : '-' }}</span>
              </div>
            </div>
            <div class="row no-gutters">
              <div>
                <span class="label">Volume ($)</span>
                <span>{{ assetValid ? _messageQuote?.volumeFinancier : '-' }}</span>
              </div>
            </div>
            <div class="row no-gutters">
              <div>
                <span class="label">Volume (Q)</span>
                <span>{{ assetValid ? _messageQuote?.volumeAmount : '-' }}</span>
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Delta">
          <div class="delta-content">
            <div class="row no-gutters">
              <span>Hora</span>
              <div class="bar" [ngClass]="{ 'invalid-asset': !assetValid }">
                <span class="bar-green" [ngStyle]="{'width.%': deltaBarsWidth?.volHora?.green }"></span>
                <span class="bar-yellow" [ngStyle]="{'width.%': deltaBarsWidth?.volHora?.yellow }"></span>
                <span class="bar-red" [ngStyle]="{'width.%': deltaBarsWidth?.volHora?.red }"></span>
              </div>
              <span>{{ assetValid ? delta?.volHora : '-' }}</span>
            </div>
            <div class="row no-gutters">
              <span>Acum.</span>
              <div class="bar" [ngClass]="{ 'invalid-asset': !assetValid }">
                <span class="bar-green" [ngStyle]="{'width.%': deltaBarsWidth?.volHoraAcum?.green }"></span>
                <span class="bar-yellow" [ngStyle]="{'width.%': deltaBarsWidth?.volHoraAcum?.yellow }"></span>
                <span class="bar-red" [ngStyle]="{'width.%': deltaBarsWidth?.volHoraAcum?.red }"></span>
              </div>
              <span>{{ assetValid ? delta?.volHoraAcum : '-' }}</span>
            </div>
            <div class="row no-gutters">
              <span>Dia</span>
              <span class="bar" [ngClass]="{ 'invalid-asset': !assetValid }">
                <span class="bar-green" [ngStyle]="{'width.%': deltaBarsWidth?.volDay?.green }"></span>
                <span class="bar-yellow" [ngStyle]="{'width.%': deltaBarsWidth?.volDay?.yellow }"></span>
                <span class="bar-red" [ngStyle]="{'width.%': deltaBarsWidth?.volDay?.red }"></span>
              </span>
              <span>{{ assetValid ? delta?.volDay : '-' }}</span>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Outros">
          <div class="others-content">
            <div class="row no-gutters">
              <div>
                <span class="label">Túnel Max</span>
                <span>{{ assetValid ? tunnelUpperLimit : '-' }}</span>
              </div>
              <div>
                <span class="label">Mercado</span>
                <span>{{ assetValid ? marketNames[_messageQuote?.marketType] : "-" }}</span>
              </div>
            </div>
            <div class="row no-gutters">
              <div>
                <span class="label">Túnel Min.</span>
                <span>{{ assetValid ? tunnelLowerLimit : '-' }}</span>
              </div>
              <div>
                <span class="label">Forma de C.</span>
                <span>{{ assetValid ? _messageQuote?.quotationForm : '-' }}</span>
              </div>
            </div>
            <div class="row no-gutters">
              <div>
                <span class="label">Cont. Aberto</span>
                <span>{{ assetValid ? quantityOpenedContractNumber : '-' }}</span>
              </div>
              <div>
                <span class="label">Lote Padrão</span>
                <span>{{ assetValid ? _messageQuote?.loteDefault : "-" }}</span>
              </div>
            </div>
            <div class="row no-gutters">
              <div>
                <span class="label">Incre. Preço</span>
                <span>{{ assetValid ? _messageQuote?.minimumIncrement : '-' }}</span>
              </div>
              <div>
                <span class="label">Multiplicad.</span>
                <span>{{ assetValid ? contractMultiplier : "-" }}</span>
              </div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>
